module.exports = "https://cdn.hellotech.com/client-assets/computers_mobile_1593fb2251e28d078530809a31389182.webp";